module.exports = __webpack_public_path__ + "media/images/icons/vendors/venues-92d367e41e4670baafcc46645cee9733.png";